module.exports = __webpack_public_path__ + "img/d15a8ca.webp";